import React from 'react';
import BookingsList from './BookingsList';

function BookingDetailsPage() {
  return (
    <section>
      <BookingsList />
    </section>
  );
}

export default BookingDetailsPage;
